

export const frontMatter = {};
export const contentTitle = 'FirstPersonView';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-reference-core-first-person-view-md-f6d.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Constructor",
  "id": "constructor",
  "level": 2
}, {
  "value": "<code>projectionMatrix</code> (number[16], optional)",
  "id": "projectionmatrix",
  "level": 4
}, {
  "value": "<code>fovy</code> (number, optional)",
  "id": "fovy",
  "level": 4
}, {
  "value": "<code>near</code> (number, optional)",
  "id": "near",
  "level": 4
}, {
  "value": "<code>far</code> (number, optional)",
  "id": "far",
  "level": 4
}, {
  "value": "<code>focalDistance</code> (number, optional)",
  "id": "focaldistance",
  "level": 4
}, {
  "value": "View State",
  "id": "view-state",
  "level": 2
}, {
  "value": "Controller",
  "id": "controller",
  "level": 2
}, {
  "value": "Source",
  "id": "source",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "firstpersonview",
        children: "FirstPersonView"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "FirstPersonView"
      }), " class is a subclass of ", _jsx(_components.a, {
        href: "/docs/api-reference/core/viewport",
        children: "View"
      }), " that describes a camera placed at a provided location, looking ", _jsx(_components.strong, {
        children: "towards"
      }), " the direction and orientation specified by ", _jsx(_components.code, {
        children: "viewState"
      }), ". The behavior is similar to that of a ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/First-person_(gaming)",
        children: "first-person game"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["It's recommended that you read the ", _jsx(_components.a, {
        href: "/docs/developer-guide/views",
        children: "Views and Projections guide"
      }), " before using this class."]
    }), "\n", _jsx("div", {
      style: {
        position: 'relative',
        height: 450
      }
    }), "\n", _jsx("div", {
      style: {
        position: 'absolute',
        transform: 'translateY(-450px)',
        paddingLeft: 'inherit',
        paddingRight: 'inherit',
        left: 0,
        right: 0
      },
      children: _jsx("iframe", {
        height: "450",
        style: {
          width: '100%'
        },
        scrolling: "no",
        title: "deck.gl FirstPersonView",
        src: "https://codepen.io/vis-gl/embed/oNYXxNE?height=450&theme-id=light&default-tab=result",
        frameborder: "no",
        loading: "lazy",
        allowtransparency: "true",
        allowfullscreen: "true",
        children: _jsxs(_components.p, {
          children: ["See the Pen ", _jsx("a", {
            href: "https://codepen.io/vis-gl/pen/oNYXxNE",
            children: "deck.gl FirstPersonView"
          }), " by vis.gl\n(", _jsx("a", {
            href: "https://codepen.io/vis-gl",
            children: "@vis-gl"
          }), ") on ", _jsx("a", {
            href: "https://codepen.io",
            children: "CodePen"
          }), "."]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "constructor",
      children: "Constructor"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import {FirstPersonView} from '@deck.gl/core';\nnew FirstPersonView({id, ...});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "FirstPersonView"
      }), " takes the same parameters as the ", _jsx(_components.a, {
        href: "/docs/api-reference/core/view",
        children: "View"
      }), " superclass constructor, plus the following:"]
    }), "\n", _jsxs(_components.h4, {
      id: "projectionmatrix",
      children: [_jsx(_components.code, {
        children: "projectionMatrix"
      }), " (number[16], optional)"]
    }), "\n", _jsx(_components.p, {
      children: "Projection matrix."
    }), "\n", _jsxs(_components.p, {
      children: ["If ", _jsx(_components.code, {
        children: "projectionMatrix"
      }), " is not supplied, the ", _jsx(_components.code, {
        children: "View"
      }), " class will build a projection matrix from the following parameters:"]
    }), "\n", _jsxs(_components.h4, {
      id: "fovy",
      children: [_jsx(_components.code, {
        children: "fovy"
      }), " (number, optional)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Field of view covered by camera, in the perspective case. In degrees. Default ", _jsx(_components.code, {
        children: "75"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "near",
      children: [_jsx(_components.code, {
        children: "near"
      }), " (number, optional)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Distance of near clipping plane. Default ", _jsx(_components.code, {
        children: "0.1"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "far",
      children: [_jsx(_components.code, {
        children: "far"
      }), " (number, optional)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Distance of far clipping plane. Default ", _jsx(_components.code, {
        children: "1000"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "focaldistance",
      children: [_jsx(_components.code, {
        children: "focalDistance"
      }), " (number, optional)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Modifier of viewport scale. Corresponds to the number of pixels per meter. Default ", _jsx(_components.code, {
        children: "1"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "view-state",
      children: "View State"
    }), "\n", _jsxs(_components.p, {
      children: ["To render, a ", _jsx(_components.code, {
        children: "FirstPersonView"
      }), " needs to be combined with a ", _jsx(_components.code, {
        children: "viewState"
      }), " object with the following parameters:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "longitude"
        }), " (number, optional) - longitude of the camera"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "latitude"
        }), " (number, optional) - latitude of the camera"]
      }), "\n"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "position"
        }), " (number[3], optional) - meter offsets of the camera from the lng-lat anchor point. Default ", _jsx(_components.code, {
          children: "[0, 0, 0]"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "bearing"
        }), " (number, optional) - bearing angle in degrees. Default ", _jsx(_components.code, {
          children: "0"
        }), " (north)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "pitch"
        }), " (number, optional) - pitch angle in degrees. Default ", _jsx(_components.code, {
          children: "0"
        }), " (horizontal)."]
      }), "\n"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "maxPitch"
        }), " (number, optional) - max pitch angle. Default ", _jsx(_components.code, {
          children: "90"
        }), " (down)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "minPitch"
        }), " (number, optional) - min pitch angle. Default ", _jsx(_components.code, {
          children: "-90"
        }), " (up)."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "controller",
      children: "Controller"
    }), "\n", _jsxs(_components.p, {
      children: ["By default, ", _jsx(_components.code, {
        children: "FirstPersonView"
      }), " uses the ", _jsx(_components.code, {
        children: "FirstPersonController"
      }), " to handle interactivity. To enable the controller, use:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "const view = new FirstPersonView({id: 'pov', controller: true});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Visit the ", _jsx(_components.a, {
        href: "/docs/api-reference/core/first-person-controller",
        children: "FirstPersonController"
      }), " documentation for a full list of supported options."]
    }), "\n", _jsx(_components.h2, {
      id: "source",
      children: "Source"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://github.com/visgl/deck.gl/tree/9.4-release/modules/core/src/views/first-person-view.ts",
        children: "modules/core/src/views/first-person-view.ts"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

